import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Account from '../components/account';
import { Attractions } from '../components/attractions';
import { FAQS } from '../components/faq';
import { FestivalForm, FestivalView } from '../components/festivals';
import Home from '../components/home';
import Login from '../components/login/Login';
import { ResetPassword } from '../components/password';
import { Performers } from '../components/performers';
import PushNotifications from '../components/push-notifications';
import { Services } from '../components/services';
import Signup from '../components/signup/Signup';
import { Sponsors } from '../components/sponsors';
import { StageFormContainer, Stages } from '../components/stages';
import { FestivalVendors } from '../components/vendors';
import ProtectedRoute from './ProtectedRoute';

export default (props) => (
  <Switch>
    <Route exact path="/login" component={Login} />
    <Route exact path="/reset-password" component={ResetPassword} />
    <Route exact path="/signup" component={Signup} />
    <ProtectedRoute exact path="/" component={Home} />
    <ProtectedRoute exact path="/account" component={Account} />
    <ProtectedRoute exact path="/stages" component={Stages} />
    <ProtectedRoute path="/stage/:id" component={StageFormContainer} />
    <ProtectedRoute exact path="/festival/:id/view" component={FestivalView} />
    <ProtectedRoute path="/festival/:id" component={FestivalForm} />
    <ProtectedRoute path="/performers" component={Performers} />
    <ProtectedRoute path="/vendors" component={FestivalVendors} />
    <ProtectedRoute path="/services" component={Services} />
    <ProtectedRoute path="/sponsors" component={Sponsors} />
    <ProtectedRoute path="/faq" component={FAQS} />
    <ProtectedRoute path="/attractions" component={Attractions} />
    <ProtectedRoute path="/push-notification" component={PushNotifications} />
  </Switch>
);
